<template>
    <div class="jackpot-t-r">
        <div class="jackpot-t-i" v-if="!_.isEmpty(jackpotData)">
            <slot v-if="!isMobile">
              <div class="j-item">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  <h1>MAÇA JACKPOT!</h1>
                  <div class="value">
                    <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="path3295" d="m9.9958 40c7.2112-1.603 7.9872-5.826 8.5312-13.594-1.253 2.075-3.531 3.607-7.25 3.594-6.1124-0.021-10.207-3.576-8.75-11.25 1.4688-7.737 12.469-10.737 17.469-18.75 5 8.0128 16 11.013 17.469 18.75 1.456 7.674-2.469 11.228-8.75 11.25-3.719 0.013-5.997-1.519-7.25-3.594 0.544 7.768 1.319 11.991 8.531 13.594h-20z"/> </g> </svg>
                      <IOdometer
                      :value="parseFloat(jackpotData.MACA)"
                      />  
                      <span class="currency">₺</span>
                  </div>
              </div>
              <div class="j-item">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  <h1>KUPA JACKPOT!</h1>
                  <div class="value">
                      <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="rect2277" d="m20 10c0.97-5 2.911-10 9.702-10 6.792 0 12.128 5 9.703 15-2.426 10-13.584 15-19.405 25-5.821-10-16.979-15-19.405-25-2.4254-10 2.9109-15 9.703-15 6.791 0 8.732 5 9.702 10z"/> </g> </svg>
                      <IOdometer
                          :value="parseFloat(jackpotData.KUPA)"
                      />  
                      <span class="currency">₺</span>
                  </div>
              </div>
              <div class="j-item">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  <h1>KARO JACKPOT!</h1>
                  <div class="value">
                     <svg x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"> <g><g><path d="M500,10L193.8,500L500,990l306.3-490L500,10z"/></g></g> </svg>
                       <IOdometer
                      :value="parseFloat(jackpotData.KARO)"
                      />  
                      <span class="currency">₺</span>
                  </div>
              </div>
              <div class="j-item">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  <h1>SİNEK JACKPOT!</h1>
                  <div class="value">
                      <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="path3395" d="m20 0c-4.731 0-8.571 4.032-8.571 9 0.041 3.126 1.654 5.768 3.333 8.281-1.871-1.416-3.951-2.272-6.1906-2.281-4.7314 0-8.5714 4.032-8.5714 9s3.84 9 8.5714 9c3.8326-0.064 6.8986-2.746 9.9106-5-0.539 6.733-1.635 10.514-8.006 12h19.048c-6.371-1.486-7.467-5.267-8.006-12 2.977 2.552 6.1 4.717 9.911 5 4.731 0 8.571-4.032 8.571-9s-3.84-9-8.571-9c-2.297 0-4.281 1.057-6.191 2.281 1.9-2.487 3.151-5.17 3.333-8.281 0-4.968-3.84-9-8.571-9z"/> </g> </svg>
                      <IOdometer
                      :value="parseFloat(jackpotData.SINEK)"
                      />  
                      <span class="currency">₺</span>
                  </div>
              </div>
            </slot>
            <slot v-if="isMobile">
              <div class="j-item" @click="jackpotModal = true">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  <h1>JACKPOT!</h1>
                  <small>Detaylar için tıklayın</small>
                  <div class="value">
                      <IOdometer
                      :value="parseFloat(totalJackpot)"
                      />  
                      <span class="currency">₺</span>
                  </div>
              </div>
            <Modal class="jackpot-modal" :isVisible="jackpotModal" @modalStatus="jackpotModal = $event">
              <template slot="content">
               <div class="jackpot-modal-row">
                 <div class="image">
                  <img  :src="$store.state.main.cdn_url + '/providers/egt.png?n'">
                  </div>
                  <div class="contents">
                    <div class="item">
                        <h1>MAÇA JACKPOT!</h1>
                        <div class="value">
                            <svg x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"> <g><g><path d="M500,10L193.8,500L500,990l306.3-490L500,10z"/></g></g> </svg>
                            <IOdometer
                            :value="parseFloat(jackpotData.MACA)"
                            />  
                            <span class="currency">₺</span>
                        </div>
                    </div>
                    <div class="item">
                        <h1>KUPA JACKPOT!</h1>
                        <div class="value">
                            <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="rect2277" d="m20 10c0.97-5 2.911-10 9.702-10 6.792 0 12.128 5 9.703 15-2.426 10-13.584 15-19.405 25-5.821-10-16.979-15-19.405-25-2.4254-10 2.9109-15 9.703-15 6.791 0 8.732 5 9.702 10z"/> </g> </svg>
                            <IOdometer
                                :value="parseFloat(jackpotData.KUPA)"
                            />  
                            <span class="currency">₺</span>
                        </div>
                    </div>
                    <div class="item">
                        <h1>KARO JACKPOT!</h1>
                        <div class="value">
                            <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="path3295" d="m9.9958 40c7.2112-1.603 7.9872-5.826 8.5312-13.594-1.253 2.075-3.531 3.607-7.25 3.594-6.1124-0.021-10.207-3.576-8.75-11.25 1.4688-7.737 12.469-10.737 17.469-18.75 5 8.0128 16 11.013 17.469 18.75 1.456 7.674-2.469 11.228-8.75 11.25-3.719 0.013-5.997-1.519-7.25-3.594 0.544 7.768 1.319 11.991 8.531 13.594h-20z"/> </g> </svg>
                            <IOdometer
                            :value="parseFloat(jackpotData.KARO)"
                            />  
                            <span class="currency">₺</span>
                        </div>
                    </div>
                    <div class="item">
                        <h1>SİNEK JACKPOT!</h1>
                        <div class="value">
                            <svg viewBox="0 0 40 40" version="1.0"> <g id="layer1"> <path id="path3395" d="m20 0c-4.731 0-8.571 4.032-8.571 9 0.041 3.126 1.654 5.768 3.333 8.281-1.871-1.416-3.951-2.272-6.1906-2.281-4.7314 0-8.5714 4.032-8.5714 9s3.84 9 8.5714 9c3.8326-0.064 6.8986-2.746 9.9106-5-0.539 6.733-1.635 10.514-8.006 12h19.048c-6.371-1.486-7.467-5.267-8.006-12 2.977 2.552 6.1 4.717 9.911 5 4.731 0 8.571-4.032 8.571-9s-3.84-9-8.571-9c-2.297 0-4.281 1.057-6.191 2.281 1.9-2.487 3.151-5.17 3.333-8.281 0-4.968-3.84-9-8.571-9z"/> </g> </svg>
                            <IOdometer
                            :value="parseFloat(jackpotData.SINEK)"
                            />  
                            <span class="currency">₺</span>
                        </div>
                    </div>
                  </div>
                </div>
              </template>
            </Modal>
            </slot>
        </div>
    </div>
</template>
  
  <script>
    import IOdometer from 'vue-odometer';
    import 'odometer/themes/odometer-theme-default.css';
  
    export default {
      components: {
        IOdometer
      },
      data() {
        return {
          jackpotModal: false,
        };
      },
      created(){
        this.$store.dispatch('jackpot/initChannels');
      }, 
      computed:{
        jackpotData(){
            return this.$store.getters['jackpot/jackpotData']        
        },
        totalJackpot(){
          return _.sumBy(_.toArray(this.jackpotData), item => Number(item));        
        }
      },
      mounted() {
      }
    };
  </script>
  
  <style lang="scss">
    #app.mobile{
      .jackpot-modal{
        padding: 20px;
        .image{
          position: absolute;
          left: 15px;
          top:10px;
          img{
            width: 120px;
          }
          .content{
            padding:10px !important;
          }
        }
        .contents{
          margin-top: 50px;
          .item{
            background: linear-gradient(90deg, rgba(0,0,0,0) 0%, var(--c) 48%, rgba(0,0,0,0) 100%);
            padding: 10px 15px;
            margin-bottom:10px;
            border-radius: 10px;
            h1{
              font-size:12px;
              margin-top:0px;
              color:var(--client-c3);
              margin-bottom:10px
            }
            .value{
              display:flex;
              align-items: center;
              svg{
                width:15px;
                height: 15px;
                margin-right: 5px;
              }
              span{
                font-size: 16px;
                font-weight:bold;
              }
            }
          }
        }
      }
    }
    #app.mobile .jackpot-t-r{
      padding: 5px;
      .j-item{
        h1{
          font-size: 24px;
          margin-bottom: 0px;
        }
        small{
          margin-bottom: 10px;
          opacity: .6;
        }
        .value{
          span{
            font-size: 30px !important;
          }
        }
      }
    }
    .jackpot-t-r{
      padding: 15px;
      .jackpot-t-i{
        display: flex;
        .j-item{
          background: rgb(0,0,0);
          background: linear-gradient(180deg, rgba(255,255,255,0.0) 0%, rgba(255,255,255,0.1) 50%);

          display: flex;
          align-items:center;
          justify-content: center;
          flex-direction: column;
          margin:10px;
          padding: 20px;
          padding-bottom: 10px;
          position: relative;
          border-radius: 20px;
          width: 100%;
          height: 100%;
          &:before,
          &:after {
              content: " ";
              display: block;
              position: absolute;
              width:100%;
              height:100%;
              top: 0px;
              left: 0px;
              border:2px solid var(--c);
              z-index:10;
              border-radius: 20px;
              box-sizing: border-box;
              -webkit-animation: clipAni 2s infinite linear;
          }

          &:before {
              -webkit-animation-delay: -2s;
              transform: rotate(-180deg);
          }

          @keyframes  clipAni{
              0%{
                clip:rect(0px,100px,100px,217px);
              }
              25%{
                clip:rect(0px,100px,3px,0px);
              }
              50%{
                clip:rect(0px,3px,100px,0px);
              }
              100%{
                clip:rect(217px,100px,100px,0px);
              }            
          }
          img{
            width: 100px;
            animation: imgZoom 4s infinite alternate forwards;
            @keyframes imgZoom {
                0%,5%     {transform: scale(1);}
                95%,100%   {transform: scale(1.1);}
            }
          }
          h1{
            font-size: 14px;
          }
          .value{
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(90deg, rgba(0,0,0,0) 0%, var(--c) 48%, rgba(0,0,0,0) 100%);
            padding: 10px;
            width: 100%;
            .iOdometer {
              margin: 0;
            }
            span{
              font-size: 20px !important; 
              font-weight: bold;
            }
            span.currency{
              margin-left: 5px !important;
            }
            svg{
              width: 20px;
              height: 20px;
              margin-right: 10px;
              animation: zoomSvg 1s infinite alternate forwards;
              @keyframes zoomSvg{
                from{
                  transform: scale(1);
                }
                to{
                  transform: scale(1.2);
                }
              }
            }
          }
        }
      }
    }
  </style>